export const data = {
  data: {
    clientContract: {
      table: {
        ref: 'Ref. Client',
        description: 'Description',
        price: 'Price',
        agreed: 'Agreed Kilograms (KG)',
        available: 'Outstanding Kilograms (KG)',
        lastOrder: 'Last Order Date',
        validity: 'Contract Validity Date'
      },
    },
  }
};
